import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../../../shared/shared.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../../directives/directives.module';
import { DailyLogPageModule } from '../../../daily-log/daily-log/daily-log.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DprAttachmentsEditPage } from './dpr-attachments-edit';
import { DprAttachmentsEditComponentComponent } from '../dpr-attachments-edit-component/dpr-attachments-edit-component';
import { NgxFileDropModule } from 'ngx-file-drop';

@NgModule({
  declarations: [
    DprAttachmentsEditPage,
    DprAttachmentsEditComponentComponent
  ],
    imports: [
        DirectivesModule,
        IonicPageModule.forChild(DprAttachmentsEditPage),
        SharedModule,
        FoundationModule,
        TextMaskModule,
        DailyLogPageModule,
        DropDownsModule,
        NgxFileDropModule,
    ],
})
export class DprAttachmentsEditPageModule {
}


// WEBPACK FOOTER //
// ./src/pages/DPR Pages/dpr-attachments/dpr-attachments-edit/dpr-attachments-edit.module.ts